import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';
import { ThemeProvider, StyledEngineProvider, createTheme } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import { muiGlobalTheme } from '@themes';
import { cloneDeep } from 'lodash';
import { colors } from '../../css';

const countryNumberFormat = {
  '+1': '(###) ###-####',
  '+61': undefined
};

function PhoneNumberCustom(props) {
  const { inputRef, onChange, phoneCode, numberFormat, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={(values) => {
        onChange({
          target: {
            name: other.name,
            value: values.value !== '' ? values.value : undefined
          }
        });
      }}
      format={numberFormat || countryNumberFormat[phoneCode]}
      placeholder={numberFormat || ''}
      mask="_"
    />
  );
}

PhoneNumberCustom.propTypes = {
  inputRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({
      current: PropTypes.oneOfType([PropTypes.elementType, PropTypes.element, PropTypes.node])
    })
  ]).isRequired,
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  phoneCode: PropTypes.string,
  numberFormat: PropTypes.string
};

PhoneNumberCustom.defaultProps = {
  phoneCode: '+1',
  numberFormat: ''
};

const customizeMuiGlobalTheme = () => {
  const newInputTheme = cloneDeep(muiGlobalTheme);
  newInputTheme.palette.text.primary = '#000';
  newInputTheme.palette.text.secondary = colors.colorGrey03;
  newInputTheme.components.MuiIconButton = {
    styleOverrides: { root: { marginBottom: '10px' } }
  };
  return createTheme(newInputTheme);
};

function PhoneNumberInput(props) {
  const { errorText, helperText, type, phoneCode, numberFormat, ...defaultProps } = props;

  const inputTheme = useRef(customizeMuiGlobalTheme());

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={inputTheme.current}>
        <TextField
          {...defaultProps}
          fullWidth
          helperText={defaultProps.error ? errorText : helperText}
          InputProps={{
            ...defaultProps.InputProps,
            ...(phoneCode && { startAdornment: <InputAdornment position="start">{phoneCode}</InputAdornment> }),
            inputComponent: PhoneNumberCustom,
            inputProps: {
              phoneCode,
              numberFormat
            }
          }}
        />
      </ThemeProvider>
    </StyledEngineProvider>
  );
}

PhoneNumberInput.propTypes = {
  errorText: PropTypes.string,
  helperText: PropTypes.string,
  type: PropTypes.string,
  phoneCode: PropTypes.string,
  numberFormat: PropTypes.string
};

PhoneNumberInput.defaultProps = {
  errorText: 'Error',
  helperText: undefined,
  type: '',
  phoneCode: '+1',
  numberFormat: ''
};

export default PhoneNumberInput;
